export interface PopUpMessage {
  PRIMARY_MESSAGE: string;
  SECONDARY_MESSAGE: string;
  THIRD_MESSAGE?: string;
}

const challengedQuestionPopUpMessage: Record<string, PopUpMessage> = {
  COMPLETED: {
    PRIMARY_MESSAGE: "All challenges re-evaluated",
    SECONDARY_MESSAGE:
      "Every challenged question for this test has been re-evaluated.",
  },
  IN_PROGRESS: {
    PRIMARY_MESSAGE: "Re-evaluation saved",
    SECONDARY_MESSAGE: "You've re-evaluated ",
    THIRD_MESSAGE: "these may belong to another subject or faculty.",
  },
};

type GetPopUpMessageFn = {
  (type: string): PopUpMessage;
  [key: string]: PopUpMessage;
};

export const getPopUpMessage: GetPopUpMessageFn = Object.assign(
  (type: string): PopUpMessage => {
    return (
      challengedQuestionPopUpMessage[type] || {
        PRIMARY_MESSAGE: "",
        SECONDARY_MESSAGE: "",
      }
    );
  },
  challengedQuestionPopUpMessage
);
